import { Component, AfterViewInit, OnDestroy, HostListener, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { navItems,navItems2 } from './_nav';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent  implements AfterViewInit, OnDestroy{

  public navItems = navItems;
  isMobile: boolean = false;
  private sidebarEl: HTMLElement | null = null;
  private onSidebarClickBound: ((event: MouseEvent) => void) | null = null;
  private updateNavItemsBound: (() => void) | null = null;
  isChatbotRoute: boolean = false;

  constructor(
    private toastService: ToastrService,
    private el: ElementRef,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.isMobile = window.innerWidth < 900;
    this.isChatbotRoute = this.router.url.startsWith('/chatbot');
  }
  ngAfterViewInit() {
    this.sidebarEl = this.el.nativeElement.querySelector('c-sidebar-nav');
    if (this.sidebarEl) {
      this.onSidebarClickBound = this.onSidebarClick.bind(this);
      this.sidebarEl.addEventListener('click', this.onSidebarClickBound, true);
    }
    this.updateNavItemsBound = this.updateNavItems.bind(this);
    window.addEventListener('resize', this.updateNavItemsBound);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isChatbotRoute = event.url.startsWith('/chatbot');
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    if (this.sidebarEl && this.onSidebarClickBound) {
      this.sidebarEl.removeEventListener('click', this.onSidebarClickBound, true);
    }
    if (this.updateNavItemsBound) {
      window.removeEventListener('resize', this.updateNavItemsBound);
    }
  }

  private isMobileDisabled(el: Element): boolean {
    const disabledGroup = el.closest('.mobile-disabled-group');
    return !!disabledGroup;
  }

  private onSidebarClick(event: MouseEvent): void {
    if (!this.isMobile) return;
    const target = event.target as HTMLElement;

    // Check parent group toggle (for "Công cụ", "EMR Form" labels themselves)
    const toggleEl = target.closest('.nav-group-toggle');
    if (toggleEl && this.isMobileDisabled(toggleEl)) {
      event.preventDefault();
      event.stopPropagation();
      this.toastService.info(`Tính năng "${toggleEl.textContent?.trim()}" chỉ hỗ trợ trên màn hình desktop.`);
      return;
    }

    // Check child links inside disabled parent groups
    const linkEl = target.closest('.sidebar-nav-link');
    if (linkEl) {
      const group = linkEl.closest('.nav-group');
      if (group && this.isMobileDisabled(group)) {
        event.preventDefault();
        event.stopPropagation();
        const toggle = group.querySelector('.nav-group-toggle') as HTMLElement;
        this.toastService.info(`Tính năng "${toggle?.textContent?.trim()}" chỉ hỗ trợ trên màn hình desktop.`);
      }
    }
  }

  updateNavItems() {
    const mobile = window.innerWidth < 900;
    this.isMobile = mobile;
    if (mobile) {
      this.navItems = navItems2; // Change to navItems2 if window width is less than 900
    } else {
      this.navItems = navItems; // Otherwise, use default navItems1
    }
  }

  // Hàm để cuộn về đầu trang
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  scrollToBottom() {
      const documentHeight = document.documentElement.scrollHeight;
      window.scrollTo({ top: documentHeight, behavior: 'smooth' });
  }

  // Logic ẩn/hiện nút khi cuộn trang
  isBottom: boolean = false;
  isShow: boolean = false;
  topPosToStartShowing = 100;


  @HostListener('window:scroll')
  checkScroll() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollPosition >= this.topPosToStartShowing) {
          this.isShow = true;
      } else {
          this.isShow = false;
      }
      // Kiểm tra vị trí để ẩn nút cuộn xuống khi đã tới cuối trang
      if ((windowHeight + scrollPosition) >= documentHeight) {
          this.isBottom = true;
      } else {
          this.isBottom = false;
      }
  }

}
